import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PortfoliosPage } from "@/features/portfolios/PortfoliosPage";

const search = z.object({
  view: z.enum(["table", "cards"]).optional(),
});

export const Route = createFileRoute("/_app/portfolios/")({
  validateSearch: search,
  component: () => <PortfoliosPage search={Route.useSearch()} />,
});
